import { render, staticRenderFns } from "./base-demo-flow.vue?vue&type=template&id=0cf88312&scoped=true&"
import script from "./base-demo-flow.vue?vue&type=script&lang=js&"
export * from "./base-demo-flow.vue?vue&type=script&lang=js&"
import style0 from "./base-demo-flow.vue?vue&type=style&index=0&id=0cf88312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf88312",
  null
  
)

export default component.exports